import { router } from "./routes";
import store from "@/store";
import modalHolder from "@/helpers/modalHolder";

router.beforeEach(async (to, from, next) => {
  const layout = to.meta.layout || "default";
  store.dispatch("common/setLayout", layout);
  if (to.name === "home" && to.query.token) {
    store.dispatch("auth/updateToken", to.query.token);
  }
  if (to.meta.event) {
    await store.dispatch("event/getEvent", to.params.id);
  }
  if (to.meta.cart && to.meta.event && store.getters["event/isServiceShown"]) {
    try {
      await store.dispatch("services/getCart", to.params.id);
    } finally {
      next();
    }
  }

  if (modalHolder.modals.length) {
    modalHolder.popInstance();
  }

  if (to.meta.authRequired && !store.getters["auth/isAuthenticated"]) {
    modalHolder.clear();
    next({ name: "login" });
  } else {
    next();
  }
});

export default router;
